import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleInvoicingUnpaidInvoicesPageTourConfig: AgTechTourConfig = {
    id: 'sale-invoicing-unpaid-page-tour',
    name: 'Unpaid Invoices Tour',
    steps: [
        {
            targetId: 'sale-invoicing-unpaid-grid',
            title: 'Unpaid Invoices Grid',
            description: 'All created invoices that haven\'t been paid yet. Click an invoice number to view its full details. Use the Pay button in each row to record a payment.',
            position: 'right',
        },
        {
            targetId: 'sale-invoicing-unpaid-count-metric',
            title: 'Processed Invoices',
            description: 'The number of invoices generated and awaiting payment.',
            position: 'left',
        },
        {
            targetId: 'sale-invoicing-unpaid-total-metric',
            title: 'Total Invoiced',
            description: 'The combined total across all outstanding unpaid invoices.',
            position: 'left',
        },
    ]
}
